import { AVAILABLE_COLUMNS_TYPES, INDICATORS, RANKINGS } from './constants'

export const getColumnsPerRanking = ranking => {
  switch (ranking) {
    case RANKINGS.COMPANIES_STATIONARY:
      return [
        INDICATORS.REVENUE_CURRENT,
        INDICATORS.REVENUE_CHANGE,
        INDICATORS.REVENUE_PER_STORE_CURRENT,
        INDICATORS.SHARE_CURRENT,
        INDICATORS.TRAFFIC_CURRENT,
        INDICATORS.TRAFFIC_PER_STORE_CURRENT,
        INDICATORS.CONVERSION_CURRENT,
        INDICATORS.TRANSACTION_VALUE_CURRENT,
        INDICATORS.REVENUE_PER_M2_CURRENT,
      ]

    case RANKINGS.WORST_20_SHOPS:
    case RANKINGS.BEST_20_SHOPS:
    case RANKINGS.STORES_OPEN_WITHIN_12_MONTHS:
    case RANKINGS.STORES_OPEN_WITHIN_30_DAYS:
      return [
        INDICATORS.REVENUE_CURRENT,
        INDICATORS.REVENUE_CHANGE,
        INDICATORS.TRAFFIC_CURRENT,
        INDICATORS.CONVERSION_CURRENT,
        INDICATORS.TRANSACTION_VALUE_CURRENT,
        INDICATORS.REVENUE_PER_M2_CURRENT,
      ]

    case RANKINGS.DISTRICT:
    case RANKINGS.RKS:
      return [
        INDICATORS.REVENUE_CURRENT,
        INDICATORS.SHARE_CURRENT,
        INDICATORS.REVENUE_PER_STORE_CURRENT,
        INDICATORS.REVENUE_CHANGE,
        INDICATORS.TRAFFIC_CURRENT,
        INDICATORS.TRAFFIC_PER_STORE_CURRENT,
        INDICATORS.CONVERSION_CURRENT,
        INDICATORS.TRANSACTION_VALUE_CURRENT,
        INDICATORS.REVENUE_PER_M2_CURRENT,
      ]

    case RANKINGS.WEBSITE_ECOMMERCE:
    case RANKINGS.COMPANIES_ECOMMERCE:
    case RANKINGS.COMPANIES_BY_CHANNELS:
      return [INDICATORS.REVENUE_CURRENT, INDICATORS.REVENUE_CHANGE, INDICATORS.SHARE_CURRENT]

    case RANKINGS.CLUB_CARD:
      return [
        INDICATORS.REVENUE_CLUB_CURRENT,
        INDICATORS.CLUB_SHARE_CURRENT,
        INDICATORS.CLUB_CARDS_CURRENT,
        INDICATORS.TRANSACTION_VALUE_CLUB_CURRENT,
        INDICATORS.REVENUE_PER_M2_CURRENT,
      ]
    case RANKINGS.HOURS_REVENUE:
      return [
        INDICATORS.COMPANIES_NECOMMERCE,
        INDICATORS.COMPANIES_ECOMMERCE,
        INDICATORS.COMPANIES_ECOMMERCE_ORDERS,
        INDICATORS.STORES_NECOMMERCE,
        INDICATORS.STORES_ECOMMERCE,
        INDICATORS.STORES_ECOMMERCE_ORDERS,
      ]

    default:
      return []
  }
}

const columnsLabels = {
  [INDICATORS.REVENUE_CURRENT]: 'rankings.revenueCurrent',
  [INDICATORS.REVENUE_CHANGE]: 'rankings.revenueChange',
  [INDICATORS.REVENUE_PER_STORE_CURRENT]: 'rankings.revenuePerStoreCurrentLabel',
  [INDICATORS.SHARE_CURRENT]: 'rankings.shareCurrent',
  [INDICATORS.TRAFFIC_CURRENT]: 'rankings.trafficCurrent',
  [INDICATORS.TRAFFIC_PER_STORE_CURRENT]: 'rankings.trafficPerStoreCurrent',
  [INDICATORS.CONVERSION_CURRENT]: 'rankings.conversionCurrent',
  [INDICATORS.TRANSACTION_VALUE_CURRENT]: 'rankings.transactionValueCurrentLabel',
  [INDICATORS.REVENUE_CLUB_CURRENT]: 'rankings.revenueClubCurrentLabel',
  [INDICATORS.CLUB_SHARE_CURRENT]: 'rankings.clubShareCurrent',
  [INDICATORS.CLUB_CARDS_CURRENT]: 'rankings.clubCardsCurrent',
  [INDICATORS.TRANSACTION_VALUE_CLUB_CURRENT]: 'rankings.transactionValueClubCurrent',
  [INDICATORS.REVENUE_PER_M2_CURRENT]: 'rankings.revenuePerM2CurrentLabel',
  [INDICATORS.COMPANIES]: 'rankings.companies',
}

export const getLabelPerColumn = column => {
  if (!column) {
    return ''
  }

  return columnsLabels[column] || `rankings.${column}`
}

export function getCurrencyPerColumn(column, currency) {
  switch (column) {
    case INDICATORS.REVENUE_CURRENT:
    case INDICATORS.REVENUE_PER_STORE_CURRENT:
      return ` ${currency}`

    default:
      return ''
  }
}

const columnsTypes = {
  [INDICATORS.REVENUE_CURRENT]: AVAILABLE_COLUMNS_TYPES.PROGRESS,
  [INDICATORS.REVENUE_CHANGE]: AVAILABLE_COLUMNS_TYPES.PERCENT,
  [INDICATORS.REVENUE_PER_STORE_CURRENT]: AVAILABLE_COLUMNS_TYPES.PROGRESS,
  [INDICATORS.SHARE_CURRENT]: AVAILABLE_COLUMNS_TYPES.PERCENT_SIMPLE,
  [INDICATORS.TRAFFIC_CURRENT]: AVAILABLE_COLUMNS_TYPES.PROGRESS,
  [INDICATORS.TRAFFIC_PER_STORE_CURRENT]: AVAILABLE_COLUMNS_TYPES.PROGRESS,
  [INDICATORS.CONVERSION_CURRENT]: AVAILABLE_COLUMNS_TYPES.PERCENT,
  [INDICATORS.TRANSACTION_VALUE_CURRENT]: AVAILABLE_COLUMNS_TYPES.CURRENCY,
  [INDICATORS.REVENUE_CLUB_CURRENT]: AVAILABLE_COLUMNS_TYPES.PROGRESS,
  [INDICATORS.CLUB_SHARE_CURRENT]: AVAILABLE_COLUMNS_TYPES.PERCENT_SIMPLE,
  [INDICATORS.CLUB_CARDS_CURRENT]: AVAILABLE_COLUMNS_TYPES.DEFAULT,
  [INDICATORS.TRANSACTION_VALUE_CLUB_CURRENT]: AVAILABLE_COLUMNS_TYPES.CURRENCY,
  [INDICATORS.REVENUE_PER_M2_CURRENT]: AVAILABLE_COLUMNS_TYPES.PROGRESS_FULL,
}

export const getTypePerColumn = column => columnsTypes[column] || AVAILABLE_COLUMNS_TYPES.PROGRESS
